import { Module } from "vuex";
import { StoreState } from "@/store/type";
import state from "./state";
import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";
import { IEntityBulkAssignmentState } from "../types";

const entityBulkAssignmentModule: Module<
  IEntityBulkAssignmentState,
  StoreState
> = {
  state,
  mutations,
  actions,
  getters,
};

export default entityBulkAssignmentModule;
